import { __extends } from "tslib";
import { TextFormat as AwaytextFormat } from "@awayjs/scene";
import { ASObject } from '@awayfl/avm2';
var TextFormat = /** @class */ (function (_super) {
    __extends(TextFormat, _super);
    function TextFormat(font, size, color, bold, italic, underline, url, link_target, align, leftMargin, rightMargin, indent, leading) {
        if (font === void 0) { font = null; }
        if (size === void 0) { size = null; }
        if (color === void 0) { color = null; }
        if (bold === void 0) { bold = null; }
        if (italic === void 0) { italic = null; }
        if (underline === void 0) { underline = null; }
        if (url === void 0) { url = null; }
        if (link_target === void 0) { link_target = null; }
        if (align === void 0) { align = null; }
        if (leftMargin === void 0) { leftMargin = null; }
        if (rightMargin === void 0) { rightMargin = null; }
        if (indent === void 0) { indent = null; }
        if (leading === void 0) { leading = null; }
        var _this = _super.call(this) || this;
        _this.adaptee = new AwaytextFormat(font, size, color, bold, italic, underline, url, link_target, align, leftMargin, rightMargin, indent, leading);
        return _this;
    }
    Object.defineProperty(TextFormat.prototype, "target", {
        get: function () {
            console.log("not implemented: TextFormat target");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat target");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "tabStops", {
        get: function () {
            console.log("not implemented: TextFormat tabStops");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat tabStops");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "display", {
        get: function () {
            console.log("not implemented: TextFormat display");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat display");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "bullet", {
        get: function () {
            console.log("not implemented: TextFormat bullet");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat bullet");
            //this._bullet = TextFormat.coerceBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "url", {
        get: function () {
            console.log("not implemented: TextFormat url");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat url");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "align", {
        get: function () {
            return this.adaptee.align;
        },
        set: function (value) {
            this.adaptee.align = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "blockIndent", {
        get: function () {
            return this.adaptee.blockIndent;
        },
        set: function (value) {
            this.adaptee.blockIndent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "leftMargin", {
        get: function () {
            return this.adaptee.leftMargin;
        },
        set: function (value) {
            this.adaptee.leftMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "rightMargin", {
        get: function () {
            return this.adaptee.rightMargin;
        },
        set: function (value) {
            this.adaptee.rightMargin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "indent", {
        get: function () {
            return this.adaptee.indent;
        },
        set: function (value) {
            this.adaptee.indent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "color", {
        get: function () {
            return this.adaptee.color;
        },
        set: function (value) {
            this.adaptee.color = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "kerning", {
        get: function () {
            return this.adaptee.kerning;
        },
        set: function (value) {
            this.adaptee.kerning = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "leading", {
        get: function () {
            return this.adaptee.leading;
        },
        set: function (value) {
            this.adaptee.leading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "letterSpacing", {
        get: function () {
            return this.adaptee.letterSpacing;
        },
        set: function (value) {
            this.adaptee.letterSpacing = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "size", {
        get: function () {
            return this.adaptee.size;
        },
        set: function (value) {
            this.adaptee.size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "bold", {
        get: function () {
            return this.adaptee.bold;
        },
        set: function (value) {
            this.adaptee.bold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "italic", {
        get: function () {
            return this.adaptee.italic;
        },
        set: function (value) {
            this.adaptee.italic = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "underline", {
        get: function () {
            return this.adaptee.underline;
        },
        set: function (value) {
            this.adaptee.underline = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "font_name", {
        get: function () {
            console.log("not implemented: TextFormat font_name");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat font_name");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "style_name", {
        get: function () {
            console.log("not implemented: TextFormat style_name");
            return null;
        },
        set: function (value) {
            console.log("not implemented: TextFormat style_name");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFormat.prototype, "font", {
        get: function () {
            console.log("not implemented: TextFormat Font getter");
            return null; //this.adaptee.font;;
        },
        set: function (value) {
            console.log("not implemented: TextFormat Font setter");
        },
        enumerable: true,
        configurable: true
    });
    TextFormat.prototype.clone = function () {
        console.log("not implemented: textFOrmat.clone");
        return null;
        /*var clonedFormat:TextFormat=new TextFormat();
        this.applyToFormat(clonedFormat);
        return clonedFormat;*/
    };
    return TextFormat;
}(ASObject));
export { TextFormat };
